module.exports = __webpack_public_path__ + "static/media/face1ok.89afd56e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/FeedbackForm/images/face1ok.svg
// module id = 1216
// module chunks = 2